module.exports = __webpack_public_path__ + "img/x-close.80799d86.svg";